require('../../../assets/scripts/candidates/add/jv.cand.add.app.js');